import React from "react";
import styles1 from "../Assets/css/PressRecognition.module.css";
import useMedia from "../componentsofcourse/useMedia";
import press from "../Assets/img/Home/press.png";
import pressMob from "../Assets/img/Home/press-mob.png";
function PressRecognition() {
	const matches = useMedia("(min-width : 768px )");
	const styles = {
		header: {
			fontFamily: "Poppins,sans-serif",
			fontWeight: "bold",
			fontSize: "50px",
			textAlign: "center",
			marginBottom: "5%",
		},
		headerMob: {
			fontFamily: "Poppins,sans-serif",
			fontWeight: "bold",
			textAlign: "center",
			marginBottom: "10%",
		},
		body: {
			margin: "auto",
			display: "block",
			width: "90%",
			marginBottom: "5%",
		},

		bodyMob: {
			margin: "auto",
			display: "block",
			width: "65%",
			marginBottom: "10%",
		},
	};
	return (
		<div>
			{matches ? (
				<div>
					<div
						style={{ paddingLeft: "50px", paddingRight: "50px" }}
						className="container-fluid"
					>
						<div className=" mx-5 p-0 my-3">
							<h1 style={styles.header}>Press Recognitions</h1>
							{/* <hr className="hr-J" /> */}
						</div>

						<div>
							<img style={styles.body} src={press} />
						</div>
					</div>
				</div>
			) : (
				<div>
					<div className="container-fluid">
						<div className=" mx-5 p-0 my-3">
							<h1 style={styles.headerMob}>
								Press <br />
								Recognitions
							</h1>
							{/* <hr className="hr-J" /> */}
						</div>

						<div>
							<img style={styles.bodyMob} src={pressMob} />
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default PressRecognition;
